import { brandConfigs, Brands, Languages } from './brandConfig'

export { Brands, Languages }

// Hosting origin (no trailing slash) -> brand. Both schemes are listed: header enrichment and
// Telkom's CORS allow-list are scheme-specific. Unknown origins fall back to Brands.Default, and
// ?brand=<id> overrides on any host (VS Gaming also runs on the Rush host with ?brand=vs-gaming).
export const brandConfigMap = new Map([
  ['http://localhost:3303', Brands.RushGames],
  ['http://play-tlk-za.rush-games.co.za', Brands.RushGames],
  ['https://play-tlk-za.rush-games.co.za', Brands.RushGames],
  ['http://play-tlk-za.blg.gg', Brands.BattleLeague],
  ['https://play-tlk-za.blg.gg', Brands.BattleLeague],
  ['http://play-tlk-za.vsforallgamers.co.za', Brands.VsGaming],
  ['https://play-tlk-za.vsforallgamers.co.za', Brands.VsGaming],
  ['http://staging-play.morabaraba-legends.co.za', Brands.Morabaraba],
  ['https://staging-play.morabaraba-legends.co.za', Brands.Morabaraba],
  ['http://play.morabaraba-legends.co.za', Brands.Morabaraba],
  ['https://play.morabaraba-legends.co.za', Brands.Morabaraba]
])

// Origins that talk to Telkom's staging Premium API unless ?env= says otherwise. public/index.html
// applies the same rule (a staging-play host) to the early /premium/he call: keep the two in step.
export const stagingOrigins = new Set([
  'http://staging-play.morabaraba-legends.co.za',
  'https://staging-play.morabaraba-legends.co.za'
])

// Telkom environment for this page load: ?env=staging|production wins, then the hosting origin,
// else production.
export function premiumEnvironment() {
  const requested = new URLSearchParams(window.location.search).get('env')
  if (requested === 'staging' || requested === 'production') return requested
  return stagingOrigins.has(window.location.origin) ? 'staging' : 'production'
}

// A brand's config for this page load: its `staging` entries (Telkom SID, game URL) replace the
// production ones when the page talks to Telkom's staging environment.
export function getBrandConfig(brandId) {
  const config = brandConfigs[brandId] || brandConfigs[Brands.Default]
  return premiumEnvironment() === 'staging' && config.staging ? { ...config, ...config.staging } : config
}
